import React from 'react';
import { FinalFormInput } from '@utex/ui-kit';
import { FinalFormFieldProps } from '@utex/ui-kit/dist/common/Form/types';
import { normalize } from './normalizer';

interface Props extends Omit<FinalFormFieldProps, 'name'> {
  name?: string;
  currency: string;
  max?: number;
  caption: React.ReactNode;
}

const currencyToSymbol: Record<string, string> = {
  USD: '$',
  RUB: '₽',
};

export const AmountInput: React.FC<Props> = ({ name, currency, max, ...props }) => (
  <FinalFormInput
    name={name || 'amount'}
    id={name || 'amount'}
    type="number"
    inputMode="decimal"
    allowedSymbols={/\d|\.|\,|^Backspace|^Delete|^Arrow/g}
    label={currencyToSymbol[currency] || '$'}
    isLabelShort
    placeholder="0"
    view="big"
    hintPosition="right"
    autoComplete="off"
    parse={normalize({ max })}
    {...props}
  />
);
